import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "./i18n";
import { NON_EN } from "./i18n";
import { LangProvider } from "./lib/i18nContext";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import LanguageSuggestion from "./components/LanguageSuggestion";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import HowWeWork from "./pages/HowWeWork";
import Quality from "./pages/Quality";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Market from "./pages/Market";
import { Privacy, Terms } from "./pages/Legal";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const id = setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 80);
        return () => clearTimeout(id);
      }
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
};

const Shell = () => (
  <LangProvider>
    <ScrollToTop />
    <Nav />
    <Outlet />
    <Footer />
    <LanguageSuggestion />
    <Toaster position="bottom-right" />
  </LangProvider>
);

const PAGES = [
  { path: "/", el: <Home /> },
  { path: "/about", el: <About /> },
  { path: "/products", el: <Products /> },
  { path: "/how-we-work", el: <HowWeWork /> },
  { path: "/quality", el: <Quality /> },
  { path: "/contact", el: <Contact /> },
  { path: "/admin", el: <Admin /> },
  { path: "/markets/:slug", el: <Market /> },
  { path: "/privacy", el: <Privacy /> },
  { path: "/terms", el: <Terms /> },
];

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route element={<Shell />}>
              {PAGES.map((p) => (
                <Route key={p.path} path={p.path} element={p.el} />
              ))}
              {NON_EN.flatMap((l) =>
                PAGES.map((p) => <Route key={l.code + p.path} path={`/${l.code}${p.path === "/" ? "" : p.path}`} element={p.el} />)
              )}
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </MotionConfig>
  );
}

export default App;
